import { Pagination } from "@/modules/common/types/Pagination";

import api from "../api";
import {
  ConfirmReleaseNoteUploadDto,
  CreateReleaseNoteDto,
  GenerateReleaseNoteUploadUrlDto,
  ListAdminReleaseNotesDto,
  ListReleaseNoteGitHubCommitsDto,
  UpdateReleaseNoteDto,
} from "../dto/admin-release-notes";
import {
  ConfirmReleaseNoteUploadResponse,
  GenerateReleaseNoteUploadUrlResponse,
  ReleaseNoteGitHubCommitsResponse,
  ReleaseNoteListItemResponse,
  ReleaseNoteResponse,
} from "../response/admin-release-notes";

export const ADMIN_RELEASE_NOTES_ENDPOINTS = {
  LIST: "/v1/admin/release-notes",
  DETAIL: (id: string) => `/v1/admin/release-notes/${id}`,
  GITHUB_COMMITS: "/v1/admin/release-notes/github-commits",
  GENERATE_UPLOAD_URL: "/v1/admin/release-notes/media/generate-upload-url",
  CONFIRM_UPLOAD: "/v1/admin/release-notes/media/confirm-upload",
};

const joinList = (values?: number[]) => (values?.length ? values.join(",") : undefined);

export const AdminReleaseNotesService = {
  list: async ({ statuses, audiences, ...params }: ListAdminReleaseNotesDto = {}): Promise<Pagination<ReleaseNoteListItemResponse>> => {
    const response = await api.get(ADMIN_RELEASE_NOTES_ENDPOINTS.LIST, {
      params: { ...params, statuses: joinList(statuses), audiences: joinList(audiences) },
    });
    return response.data;
  },

  get: async (id: string): Promise<ReleaseNoteResponse> => {
    const response = await api.get(ADMIN_RELEASE_NOTES_ENDPOINTS.DETAIL(id));
    return response.data;
  },

  create: async (data: CreateReleaseNoteDto): Promise<ReleaseNoteResponse> => {
    const response = await api.post(ADMIN_RELEASE_NOTES_ENDPOINTS.LIST, data);
    return response.data;
  },

  update: async (id: string, data: UpdateReleaseNoteDto): Promise<ReleaseNoteResponse> => {
    const response = await api.put(ADMIN_RELEASE_NOTES_ENDPOINTS.DETAIL(id), data);
    return response.data;
  },

  remove: async (id: string): Promise<void> => {
    await api.delete(ADMIN_RELEASE_NOTES_ENDPOINTS.DETAIL(id));
  },

  listGitHubCommits: async (params: ListReleaseNoteGitHubCommitsDto): Promise<ReleaseNoteGitHubCommitsResponse> => {
    const response = await api.get(ADMIN_RELEASE_NOTES_ENDPOINTS.GITHUB_COMMITS, { params });
    return response.data;
  },

  generateUploadUrl: async (data: GenerateReleaseNoteUploadUrlDto): Promise<GenerateReleaseNoteUploadUrlResponse> => {
    const response = await api.post(ADMIN_RELEASE_NOTES_ENDPOINTS.GENERATE_UPLOAD_URL, data);
    return response.data;
  },

  confirmUpload: async (data: ConfirmReleaseNoteUploadDto): Promise<ConfirmReleaseNoteUploadResponse> => {
    const response = await api.post(ADMIN_RELEASE_NOTES_ENDPOINTS.CONFIRM_UPLOAD, data);
    return response.data;
  },
};
